<template>
  <v-card class="mt-0" outlined :loading="loading">
    <v-card-title class="justify-center"> Downgrades (YTD) </v-card-title>
    <v-card-text>
      <template>
        <div>
          <vue-apex-charts
            type="area"
            :options="chartOptions"
            :series="series"
            :height="240"
          ></vue-apex-charts>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { getDowngradesGraph } from "../../api/subscription";
import { startOfYear, endOfToday, setYear } from "date-fns";
import VueApexCharts from "vue-apexcharts";
export default {
  name: "DowngradesGraph",

  components: { VueApexCharts },

  data() {
    return {
      loading: false,
      periods: [],
      series: []
    };
  },

  computed: {
    chartOptions() {
      const periods = this.periods;
      return {
        chart: {
          id: "downgrades-graph",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: true
        },
        stroke: {
          curve: "straight"
        },
        tooltip: {
          enabled: true,
          shared: true
        },
        xaxis: {
          categories: periods
        },
        yaxis: {
          forceNiceScale: true
        }
      };
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(
      startDate = setYear(startOfYear(new Date()), 2022),
      endDate = endOfToday()
    ) {
      try {
        this.loading = true;

        const result = await getDowngradesGraph(startDate, endDate);
        this.periods = result.items.map(item => item.date);
        this.series = [
          {
            name: "All Downgrades",
            data: result.items.map(item => item.total)
          },
          {
            name: "Customer Downgraded",
            data: result.items.map(item => item["customer-downgrade"])
          },
          {
            name: "Payment Failure",
            data: result.items.map(item => item["payment-failure"])
          },
          {
            name: "Manual Downgrade",
            data: result.items.map(item => item["manual-downgrade"])
          }
        ];

        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    }
  }
};
</script>

<style scoped></style>
